import React from 'react';
import { motion } from 'framer-motion';
import { Upload } from 'lucide-react';
export function SettingsPage() {
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} animate={{
    opacity: 1,
    y: 0
  }} className="max-w-5xl mx-auto flex gap-8" data-id="element-4380">
      {/* Left Subnav */}
      <div className="w-64 shrink-0" data-id="element-4381">
        <h2 className="text-2xl font-bold mb-6" data-id="element-4382">Settings</h2>
        <nav className="space-y-1" data-id="element-4383">
          <button className="w-full text-left px-3 py-2 rounded-lg bg-primary/10 text-primary font-medium text-sm" data-id="element-4384">
            Organization
          </button>
          <button className="w-full text-left px-3 py-2 rounded-lg text-textMuted hover:bg-surface hover:text-textMain transition-colors text-sm" data-id="element-4385">
            Billing
          </button>
          <button className="w-full text-left px-3 py-2 rounded-lg text-textMuted hover:bg-surface hover:text-textMain transition-colors text-sm" data-id="element-4386">
            Email & Sending
          </button>
          <button className="w-full text-left px-3 py-2 rounded-lg text-textMuted hover:bg-surface hover:text-textMain transition-colors text-sm" data-id="element-4387">
            Calendar Integrations
          </button>
          <button className="w-full text-left px-3 py-2 rounded-lg text-textMuted hover:bg-surface hover:text-textMain transition-colors text-sm" data-id="element-4388">
            Templates
          </button>
          <button className="w-full text-left px-3 py-2 rounded-lg text-textMuted hover:bg-surface hover:text-textMain transition-colors text-sm" data-id="element-4389">
            Negotiation Rules
          </button>
          <button className="w-full text-left px-3 py-2 rounded-lg text-textMuted hover:bg-surface hover:text-textMain transition-colors text-sm" data-id="element-4390">
            Booking Confirmation Rules
          </button>
          <button className="w-full text-left px-3 py-2 rounded-lg text-textMuted hover:bg-surface hover:text-textMain transition-colors text-sm" data-id="element-4391">
            Venue Preferences
          </button>
          <button className="w-full text-left px-3 py-2 rounded-lg text-textMuted hover:bg-surface hover:text-textMain transition-colors text-sm" data-id="element-4392">
            Notifications
          </button>
          <button className="w-full text-left px-3 py-2 rounded-lg text-textMuted hover:bg-surface hover:text-textMain transition-colors text-sm" data-id="element-4393">
            Integrations
          </button>
          <button className="w-full text-left px-3 py-2 rounded-lg text-textMuted hover:bg-surface hover:text-textMain transition-colors text-sm" data-id="element-4394">
            Security
          </button>
        </nav>
      </div>

      {/* Main Content */}
      <div className="flex-1 max-w-2xl" data-id="element-4395">
        <div className="bg-surface border border-border rounded-xl p-8" data-id="element-4396">
          <h3 className="text-lg font-semibold mb-6 border-b border-border pb-4" data-id="element-4397">
            Organization Profile
          </h3>

          <div className="space-y-6" data-id="element-4398">
            {/* Logo Upload */}
            <div data-id="element-4399">
              <label className="block text-sm font-medium mb-2 text-textMuted" data-id="element-4400">
                Organization Logo
              </label>
              <div className="flex items-center gap-4" data-id="element-4401">
                <div className="w-16 h-16 rounded-lg bg-background border border-border flex items-center justify-center text-xl font-bold text-textMuted" data-id="element-4402">
                  W
                </div>
                <button className="px-3 py-2 bg-background border border-border rounded-lg text-sm font-medium hover:bg-surfaceHover transition-colors flex items-center gap-2" data-id="element-4403">
                  <Upload className="w-4 h-4" data-id="element-4404" /> Upload new
                </button>
              </div>
            </div>

            {/* Form Fields */}
            <div data-id="element-4405">
              <label className="block text-sm font-medium mb-2 text-textMuted" data-id="element-4406">
                Organization Name
              </label>
              <input type="text" defaultValue="The Wildwoods" className="w-full px-4 py-2 bg-background border border-border rounded-lg text-sm focus:outline-none focus:border-primary transition-colors" data-id="element-4407" />
            </div>

            <div data-id="element-4408">
              <label className="block text-sm font-medium mb-2 text-textMuted" data-id="element-4409">
                Primary Contact Email
              </label>
              <input type="email" defaultValue="booking@thewildwoodsband.com" className="w-full px-4 py-2 bg-background border border-border rounded-lg text-sm focus:outline-none focus:border-primary transition-colors" data-id="element-4410" />
            </div>

            <div className="grid grid-cols-2 gap-4" data-id="element-4411">
              <div data-id="element-4412">
                <label className="block text-sm font-medium mb-2 text-textMuted" data-id="element-4413">
                  Default Timezone
                </label>
                <select className="w-full px-4 py-2 bg-background border border-border rounded-lg text-sm focus:outline-none focus:border-primary transition-colors appearance-none" data-id="element-4414">
                  <option data-id="element-4415">Central Time (US & Canada)</option>
                  <option data-id="element-4416">Eastern Time (US & Canada)</option>
                  <option data-id="element-4417">Pacific Time (US & Canada)</option>
                </select>
              </div>
              <div data-id="element-4418">
                <label className="block text-sm font-medium mb-2 text-textMuted" data-id="element-4419">
                  Default Currency
                </label>
                <select className="w-full px-4 py-2 bg-background border border-border rounded-lg text-sm focus:outline-none focus:border-primary transition-colors appearance-none" data-id="element-4420">
                  <option data-id="element-4421">USD ($)</option>
                  <option data-id="element-4422">CAD ($)</option>
                  <option data-id="element-4423">EUR (€)</option>
                  <option data-id="element-4424">GBP (£)</option>
                </select>
              </div>
            </div>

            <div className="pt-6 border-t border-border flex justify-end" data-id="element-4425">
              <button className="px-6 py-2 bg-primary text-background rounded-lg hover:bg-primaryHover transition-colors font-medium text-sm" data-id="element-4426">
                Save Changes
              </button>
            </div>
          </div>
        </div>
      </div>
    </motion.div>;
}